export const AppRoutes = {
  miniHealthChecks: "mini-health-checks",
  waterTracker: "/water",
  stepsTracker: "/steps",
  activityTracker: "/general-activity",
  breathingExercises: "/breathing-exercises",
  sleepTracker: "/sleep",
  wellbeing: "/wellbeing",
  account: "/account",
  accountSecurity: "/account-security",
  index: "/",
  home: "/home",
  resources: "/resources",
} as const;

export const getSupportRoute = (isMobileApp: boolean) => (isMobileApp ? "/mobile-support" : "/support");

export type AppRoute = (typeof AppRoutes)[keyof typeof AppRoutes];
